var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileImageLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.66797V3.33464H4.16667V16.668H15.8333V6.66797H12.5ZM2.5 2.49447C2.5 2.03801 2.87291 1.66797 3.33208 1.66797H13.3333L17.4998 5.83464L17.5 17.4951C17.5 17.9587 17.1292 18.3346 16.6722 18.3346H3.32783C2.87063 18.3346 2.5 17.9552 2.5 17.5081V2.49447ZM9.16667 7.91797C9.16667 8.6083 8.607 9.16797 7.91667 9.16797C7.22631 9.16797 6.66667 8.6083 6.66667 7.91797C6.66667 7.22761 7.22631 6.66797 7.91667 6.66797C8.607 6.66797 9.16667 7.22761 9.16667 7.91797ZM14.5833 14.168L11.25 8.33464L6.66667 14.168H14.5833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImageLine);
export default __webpack_public_path__ + "static/media/file-image-line.9c203c30edc7c9f637b815ccfc513494.svg";
export { ForwardRef as ReactComponent };